import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #f7f7f7;
`;

export const ContentArea = styled.div`
  flex: 1;
  padding: 24px 32px 40px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const TitleArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const PageTitle = styled.span`
  font-size: 26px;
  font-weight: 700;
  color: #0b4f6c;
`;

export const PageSubtitle = styled.span`
  font-size: 14px;
  color: #666;
`;

export const Card = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #E3F2FD;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.04);
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
  align-items: end;
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Label = styled.label`
  font-size: 13px;
  font-weight: 600;
  color: #333;
`;

export const Input = styled.input`
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 14px;
  background: #fff;
`;

export const Select = styled.select`
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 14px;
  background: #fff;
`;

export const ActionsRow = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 16px;
`;

export const PrimaryButton = styled.button`
  border: none;
  background: #0b4f6c;
  color: #fff;
  padding: 10px 18px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const SecondaryButton = styled.button`
  border: 1px solid #0b4f6c;
  background: #fff;
  color: #0b4f6c;
  padding: 10px 18px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const StatusText = styled.span`
  font-size: 13px;
  color: #666;
`;

export const ErrorText = styled.span`
  font-size: 13px;
  color: #d32f2f;
`;

export const ResultGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
`;

export const ResultItem = styled.div`
  background: #E3F2FD;
  border-radius: 10px;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ResultLabel = styled.span`
  font-size: 12px;
  text-transform: uppercase;
  color: #666;
  letter-spacing: 0.04em;
`;

export const ResultValue = styled.span`
  font-size: 18px;
  font-weight: 700;
  color: #0b4f6c;
`;

export const List = styled.ul`
  margin: 0;
  padding-left: 18px;
  font-size: 13px;
  color: #666;
  line-height: 1.4;
`;
